import React from "react";
import './mobile.css'
import  {FireTable} from "../../components/Tables/FireTable";
import Counties from "../../config/CountiesConfig";
import {DateUtils} from "../../utils/dateUtils";
import {MobileContributionTable} from "../../components/Tables/MobileContributionTable";


export class Mobile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            county: Counties[0],
            cst: DateUtils.getForecastStartCST(),
        }
    }

    _renderCountySelector() {
        return (
            <div className="select-wrapper">
                <select
                    value={this.state.county.id}
                    onChange={(e) =>
                        this.setState({
                            county: Counties.find(c => c.id === Number(e.target.value)),
                        })
                    }
                >
                    {Counties.map(option => (
                        <option key={option.id} value={option.id}>
                            {option.displayName}
                        </option>
                    ))}
                </select>

            </div>
        )
    }

    render() {

        document.title = "Kansas Flint Hills Smoke Management - Mobile Friendly";

        return (
            <div className={"mobile"}>

                <div className={'mobile-paragraph'}>
                    <a className={'mobile-paragraph'} href="/view/about">
                        {this.props.i18n.Mobile_View_Full_Site}
                    </a>
                </div>

                <div className={'mobile-paragraph'}>
                    {this.props.i18n.Mobile_Disclaimer}
                </div>

                <div className={'mobile-paragraph'}>
                    {this.props.i18n.Mobile_Select_County}
                </div>


                {this._renderCountySelector()}

                <MobileContributionTable
                    county={this.state.county}
                    cst={this.state.cst}
                    i18n={this.props.i18n}
                />

                <FireTable i18n={this.props.i18n}/>

                <div className={'about-subtitle'}>
                    {this.props.i18n.About_Cumulative_Title}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.Mobile_Cumulative_P1}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.Mobile_Cumulative_P2}
                </div>

            </div>
        )
    }

}

